import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Typography, Paper, Stack, Box, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ThumbnailModal from './ThumbnailModal';
import VideoTitle from './VideoTitle';
import VideoDescription from './VideoDescription';

import { milliSecondsToFormattedTime } from '@utils/milliSecondsToFormattedTime';

const VideoMetaSection = ({ videoDurationTime }) => {
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedThumbURL, setSelectedThumbURL] = useState('');
    const [idx, setIdx] = useState(0);
    const [loadingThumbnails, setLoadingThumbnails] = useState(Array(5).fill(true));

    const { uuid } = useParams();
    const vodInfo = useSelector((state: any) => state.media.vodInfo);
    const cdn = useSelector((state: any) => state.organization.cdn);

    const handleModal = (url: string, idx: number) => {
        if (!modalOpen) {
            setModalOpen(true);
            setSelectedThumbURL(url);
            setIdx(idx);
        }
    };

    const thumbnailRendering = () => {
        return Array.from({ length: 5 }, (_, i) => (
            <div
                key={i}
                className="thumbnail-item"
                onClick={() => handleModal(`${cdn}/${uuid}/thumbnail/tn_${i + 1}.png`, i)}
            >
                {loadingThumbnails[i] && (
                    <Skeleton
                        variant="rectangular"
                        className="skeleton__rectangular-thumbnail"
                    />
                )}
                <img
                    src={`${cdn}/${uuid}/thumbnail/tn_${i + 1}.png`}
                    onLoad={() => setLoadingThumbnails(prev => {
                        const newLoadingThumbnails = [...prev];
                        newLoadingThumbnails[i] = false;
                        return newLoadingThumbnails;
                    })}
                    className="thumbnail-image"
                    style={{ display: loadingThumbnails[i] ? 'none' : 'block' }}
                />
            </div>
        ));
    };

    return (
        <>
            {
                vodInfo && Object.keys(vodInfo).length > 0 ? (
                    <div className="video-info-tab__metadata-wrapper-container">
                        <div className="video-info-tab__metadata-wrapper">
                            <Box className="video-info-tab__metadata-header">
                                <Box className="video-info-tab__metadata-title-row">
                                    <VideoTitle />
                                </Box>
                            </Box>
                            <Box className="video-info-tab__metadata-section">
                                <Stack className="stack__spacing-2">
                                    <Box className="box__video-description">
                                        <Typography variant="h6" className="video-info-tab__video-description__title">설명</Typography>
                                        <VideoDescription />
                                    </Box>
                                    <Box className="box__flex-center">
                                        <Box>
                                            <Typography variant="caption" className="typography__caption-secondary">
                                                {t('vod.manage.info_tab.resolution')}
                                            </Typography>
                                            <Typography variant="body2" className="typography__body2-primary-no-break">{vodInfo.videoSize}</Typography>
                                        </Box>
                                        <Box className="video-info-tab__metadata-flexgrow" />
                                        <Box className="video-info-tab__metadata-duration">
                                            <Typography variant="caption" className="typography__caption-secondary">
                                                {t('vod.manage.info_tab.duration')}
                                            </Typography>
                                            <Typography variant="body2" className="typography__body2-primary-no-break">{milliSecondsToFormattedTime(videoDurationTime)}</Typography>
                                        </Box>
                                    </Box>
                                </Stack>
                            </Box>
                        </div>
                        <Box className="video-info-tab__metadata-thumbnail-row">
                            <Typography variant="h6" className="video-info-tab__video-description__title">썸네일</Typography>
                            <div className="thumbnails-container">{thumbnailRendering()}</div>
                        </Box>
                    </div>
                ) : (
                    <Paper elevation={3} className="video-info-tab__metadata-wrapper paper__elevation-3">
                        <Box className="box__flex-grow-1 box__margin-bottom-2">
                            <Box>
                                <Skeleton variant="text" className="skeleton__text-full" />
                                <Skeleton variant="text" className="skeleton__text-80" />
                            </Box>
                        </Box>
                        <Box className="box__border-top">
                            <Stack className="stack__spacing-2">
                                <Box>
                                    <Skeleton variant="text" className="skeleton__text-full" />
                                </Box>
                                <Box className="box__flex-center">
                                    <Box className="box__width-30">
                                        <Skeleton variant="text" className="skeleton__text-full" />
                                        <Skeleton variant="text" className="skeleton__text-50" />
                                    </Box>
                                    <Box className="video-info-tab__metadata-flexgrow" />
                                    <Box className="box__width-50">
                                        <Skeleton variant="text" className="skeleton__text-full" />
                                        <Skeleton variant="text" className="skeleton__text-70" />
                                    </Box>
                                </Box>
                            </Stack>
                        </Box>
                    </Paper>
                )
            }


            <ThumbnailModal modalOpen={modalOpen} setModalOpen={setModalOpen} url={selectedThumbURL} idx={idx} />
        </>
    );
};

export default VideoMetaSection; 